import { Component, ChangeDetectionStrategy, inject, signal, computed, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { OverlayBadge } from 'primeng/overlaybadge';
import { Popover, PopoverModule } from 'primeng/popover';
import { NotificacionSignalRService } from '@core/services/notificacion-signalr.service';
import { NotificacionDto } from '@core/models/notificacion.model';

@Component({
  selector: 'app-campana-notificaciones',
  standalone: true,
  imports: [CommonModule, ButtonModule, OverlayBadge, PopoverModule],
  templateUrl: './campana-notificaciones.component.html',
  styleUrl: './campana-notificaciones.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampanaNotificacionesComponent implements OnInit {
  public readonly notificacionService = inject(NotificacionSignalRService);
  public readonly panelVisible = signal(false);
  public readonly cantidadNoLeidas = computed(() => this.notificacionService.notificaciones().length);

  private readonly router = inject(Router);

  public ngOnInit(): void {
    void this.notificacionService.iniciar();
  }

  public alternarPanel(event: Event, panel: Popover): void {
    panel.toggle(event);
  }

  public onClickNotificacion(notificacion: NotificacionDto, indice: number, panel: Popover): void {
    this.notificacionService.marcarComoLeida(indice);
    if (notificacion.rutaNavegacion) {
      panel.hide();
      void this.router.navigate([notificacion.rutaNavegacion]);
    }
  }

  public marcarTodasLeidas(): void {
    this.notificacionService.marcarTodasComoLeidas();
  }
}
